import React, { useEffect } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { JudgmentsList } from '../../components/Judgments/JudgmentsList';
import { useSzafir } from '../../../common/hooks/useSzafir';
import { useAuth } from '../../../common/hooks/useAuth';
import { TabsHistory } from '../../../app/components/TabsHistory';

export const JudgmentsView: React.FC = () => {
  const szafir = useSzafir();
  const auth = useAuth();

  useEffect(() => {
    if (auth.canSign) {
      szafir.activate(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.canSign]);

  return (
    <Card>
      <TabsHistory activeKey="search" id="judgments" className="mb-3">
        <Tab eventKey="search" title="Orzeczenia" className="m-3">
          <JudgmentsList />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
